var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66702 15.6643C7.39273 15.6643 7.11844 15.5598 6.9095 15.3503C6.4911 14.9319 6.4911 14.2537 6.9095 13.8353L19.7669 0.977864C20.1853 0.559462 20.8636 0.559462 21.282 0.977864C21.7004 1.39627 21.7004 2.0745 21.282 2.4929L8.42454 15.3503C8.21561 15.5598 7.94131 15.6643 7.66702 15.6643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66703 15.658C7.39274 15.658 7.11898 15.5535 6.90951 15.344L0.480794 8.91531C0.0623916 8.49691 0.0623916 7.81814 0.480794 7.39974C0.898661 6.98134 1.57743 6.98134 1.99583 7.39974L8.42455 13.8285C8.84295 14.2469 8.84295 14.9251 8.42455 15.3435C8.21561 15.5535 7.94132 15.658 7.66703 15.658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7a03441844f26b7d97eadcc662c2a511.svg";
export { ForwardRef as ReactComponent };